import React from 'react';

import { VehicleModel, vehicleModelInitial } from '../../Models/VehicleModel';
export interface IVehicleContextProps {
    vehicle: VehicleModel,
    setVehicle: (vehicle: VehicleModel) => void,
    vehicleList: VehicleModel[],
    setVehicleList: (vehicles: VehicleModel[]) => void,
}

export const vehicleContextInitial: IVehicleContextProps = {
    vehicle: vehicleModelInitial,
    setVehicle: () => { ''; },
    vehicleList: [vehicleModelInitial],
    setVehicleList: () => { ''; },
};

export const VehicleContext = React.createContext(vehicleContextInitial);